import axios from "./axios";

/** POST /api/broker-gateway/repeat-order/ — place again from existing order(s) */
export const repeatOrders = async (orderList) => {
  const payload = { order_list: orderList };
  const response = await axios.post("/api/broker-gateway/repeat-order/", payload);
  return response.data;
};
